import React from "react"
import { Box, Paper, Typography } from "@material-ui/core"
import clsx from "clsx"
import useStyles from "@/pages/Admin/Templates/components/TemplateMethodCard/styles"

type TemplateMethodCardProps = {
	icon: JSX.Element
	title: string
	description: string
	onClick: () => void
	pulse?: boolean
}

const TemplateMethodCard: React.FC<TemplateMethodCardProps> = ({ icon, title, description, onClick, pulse }) => {
	const classes = useStyles()

	return (
		<Paper
			variant="outlined"
			className={clsx(classes.card, { [classes.pulsing]: pulse })}
			onClick={onClick}
		>
			<Box className={classes.iconWrapper}>
				{icon}
			</Box>

			<Typography variant="subtitle1" style={{ fontWeight: 600 }}>
				{title}
			</Typography>

			<Typography variant="body2" color="textSecondary">
				{description}
			</Typography>
		</Paper>
	)
}

export default TemplateMethodCard
